import { observer } from "mobx-react-lite"
import React, { useEffect, useState, useCallback } from "react"
import styled, { useTheme } from "~/ui/styled"
import useNavigation from "~hooks/useNavigation"
import { ContactList as ContactListComponent } from "~components/contact-list"
import { useRouteContext } from "~/context/route-context"
import { SocketStates } from "~/models/websocket-store"
import { useStores } from "~models"
import { SearchBarWithAvatars } from "~components/search-bar-with-avatars"
import FriendAccordion from "./components/FriendAccordion"
import { ColumnFlex } from "~components/El"

const Container = styled(ColumnFlex)`
  flex: 1;
  min-height: 0;
  width: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
`

const HeaderArea = styled(ColumnFlex)`
  height: auto;
  width: 100%;
  align-items: stretch;
`

const ListArea = styled(ColumnFlex)`
  flex: 1;
  min-height: 0;
  width: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const ContactList: React.FC = () => {
  const theme = useTheme()
  const { curRouteName } = useRouteContext()
  const navigation = useNavigation()
  const {
    contactStore,
    websocketStore: { state },
  } = useStores()
  const [needRefreshOnlineStatus, setNeedRefreshOnlineStatus] = useState(false)
  const [search, setSearch] = useState("")

  const onItemClick = useCallback((contact) => {
    navigation.push("PersonalCard", { userId: contact.user.id })
  }, [])

  useEffect(() => {
    contactStore.fetchOnline()
  }, [])

  useEffect(() => {
    if (state === SocketStates.RECONNECTING && curRouteName === "ContactList") {
      setNeedRefreshOnlineStatus(true)
    }
  }, [state])

  useEffect(() => {
    if (needRefreshOnlineStatus) {
      setNeedRefreshOnlineStatus(false)
      contactStore.fetchOnline()
    }
  }, [needRefreshOnlineStatus])

  return (
    <Container bg={theme.colors.blockBackground}>
      <HeaderArea>
        <SearchBarWithAvatars
          selecteds={[]}
          search={search}
          setSearch={setSearch}
          inputSetting={{
            placeholder: "搜索好友",
          }}
        />
        <FriendAccordion />
      </HeaderArea>
      <ListArea>
        <ContactListComponent
          sections={[...contactStore.byNameWithFilter(new RegExp(search, "i"))]}
          onItemClick={onItemClick}
        />
      </ListArea>
    </Container>
  )
}

export default observer(ContactList)
